module.exports = __webpack_public_path__ + "static/Roper-93ce5a5ea81a6584971e59e1b09821f9.jpg";